import User_Minimal from './User_Minimal'
import User_Customers from './User_Customers'

const UserFragments = {
    User_Minimal,
    User_Customers,
}

export default UserFragments
